// 删除账号提示界面 1

require("clover/panel/component/common/UIGroupButton")

let AccountDelTipPanel = xClass("AccountDelTipPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack"
)
AccountDelTipPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountDelTipPanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountDelTipPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountDelTipPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.aManager = AccountManager.getInstance()

    self.aManager.dcDelTipPanelOpen()
    self.initUI();
}
AccountDelTipPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountDelTipPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {
    if (self.lastTimeTask){
        clearInterval(self.lastTimeTask);
    }
}


AccountDelTipPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_remind.csb")
    self.addChild(self.mainNode);
    self.mainNode.y = 200

    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
    }, true);

    self.mainNode.getChildByName("txt2").setVisible(false)
    self.mainNode.getChildByName("txt3").setVisible(false)


    this.btnConfirm = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        self.aManager.dcDelTipPanelClick()

        if (SnsProxy.getInstance().supportCustomerService()){
            if (window.mini && mini.getPlatform() == MiniPlatform.tt){
                self.aManager.showDelTipAgainPanel() //抖音api只能创建按钮这里暂时不处理
            }else{
                self.aManager.showProposePanel()
            }
        }else{
            self.aManager.showDelTipAgainPanel()
        }
        this.onClose();
        this.isbusy = false
    }, true);

    this.btnConfirm.setEnabled(false);
    this.btnConfirm.getChildByName("txt").setVisible(false)

    
    this.delTime = MetaManager.getDeleteAccountConfig().delete_countdown || 3
    let updateBtn = ()=>{
  
        if (this.delTime>0){
            this.btnConfirm.getChildByName("txt").setVisible(false)
            this.btnConfirm.getChildByName("txt2").setString(`继续删除(${this.delTime})`)
        }else{
            this.btnConfirm.getChildByName("txt").setVisible(true)
            this.btnConfirm.getChildByName("txt2").setVisible(false)
            this.btnConfirm.getChildByName("txt").setString(`继续删除`)
            this.btnConfirm.setEnabled(true);
            clearInterval(self.lastTimeTask);

        }
        this.delTime--
    }

    updateBtn()
    self.lastTimeTask = setInterval(() => {
        updateBtn()
    }, 1000);

    // let txtString = "亲爱的小村民，您正在进行{c=155,91,63,255/c}账号删除{c=215,42,31,255/c}操作，继续将会导致：\n1.您的{c=155,91,63,255/c}风车币，道具{c=215,42,31,255/c}等物品将会删除\n2.您的主线关、活动关等游戏数据被删除\n3.您的账户信息会被删除，并且无法找回{c=155,91,63,255/c}"
    let txtString = getText("delete.page1.text")
    let colorLabel= getColorTextH5(txtString,16,24)
    colorLabel.x = -colorLabel.width/2
    // colorLabel.y = -colorLabel.height/2
    colorLabel.y = 90

    // colorLabel.x = -110
    this.mainNode.addChild(colorLabel)

    // let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_panel_frame_generalpanel_orange.png", cc.rect(50, 50, 150, 100))
    // this.mainNode.addChild(bg);
    // bg.setAnchorPoint(cc.p(0, 1))
    // bg.y = 90
    // bg.width = 50;
    // bg.height = colorLabel.height;
}
module.exports = AccountDelTipPanel